import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
// import { zonedTimeToUtc } from 'date-fns-tz';

import api from 'services/api';
import { show } from 'store/modules/dialog/actions';

import Input from 'components/Input';
import Card from 'components/Card';
import Tooltip from 'components/Tooltip';
import Flag from 'components/Flag';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import Loader from 'components/ContentLoader/ComerciaisNaoGravadosLoader';
import Checkbox from 'components/Checkbox';

import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import {
  FiSearch,
  FiCheckSquare,
  FiSquare,
  FiMinusSquare,
  FiTv,
  FiArrowLeft,
  FiCheck,
} from 'react-icons/fi';

import { Scroll, Td, Align } from 'styles/global';
import { Container, Table, TdFlag } from './styles';
import { EnviaExibidor } from 'pages/@types';
import { FormHandles } from '@unform/core';
import PlayerBaixa from 'components/PlayerBaixa';
import { StatusEnviaExibidor } from 'utils/variables';
import AppError from 'utils/AppError';

export default function ComerciaisSemPlanilha() {
  /**
   * REDUX
   * */
  const dispatch = useDispatch();
  const { emissora } = useSelector((state: any) => state.usuario);
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );

  /*
   * VARIAVEIS
   */

  const [selected, setSelected] = useState<EnviaExibidor>({} as EnviaExibidor);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [search, setSearch] = useState('');
  const [semPlanilha, setSemPlanilha] = useState<EnviaExibidor[]>([]);
  const [multipleSelect, setMultipleSelect] = useState<number[]>([]);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  /**
   * REFS
   */

  const formTableRef = useRef<FormHandles>(null);
  const navigate = useNavigate();

  /**
   * FUNÇÕES
   */

  const handleSelectEnvio = useCallback(
    sp => {
      if (multipleSelect.includes(sp.id)) {
        setMultipleSelect(multipleSelect.filter(x => x !== sp.id));
        if (formTableRef && formTableRef.current)
          formTableRef.current.clearField(`checkbox_${sp.id}`);
      } else {
        if (formTableRef && formTableRef.current)
          formTableRef.current.setFieldValue(`checkbox_${sp.id}`, [
            { id: sp.id, label: '', checked: true },
          ]);

        setMultipleSelect([...multipleSelect, sp.id]);
      }
    },
    [multipleSelect],
  );

  const handleSelectAll = useCallback(
    (event, select) => {
      event.preventDefault();
      if (select) {
        setMultipleSelect(semPlanilha.map(sp => sp.id));
        semPlanilha.forEach(sp => {
          if (formTableRef && formTableRef.current)
            formTableRef.current.setFieldValue(`checkbox_${sp.id}`, [
              { id: sp.id, label: '', checked: true },
            ]);
        });
      } else {
        setMultipleSelect([]);
        semPlanilha.forEach(sp => {
          if (formTableRef && formTableRef.current)
            formTableRef.current.clearField(`checkbox_${sp.id}`);
        });
      }
    },
    [semPlanilha],
  );

  const handleMidiaAtribuida = useCallback(async (e, midiaSemPlanilha) => {
    setSelected(midiaSemPlanilha);
    const isMultiple = multipleSelect.length > 1;

    const ids = isMultiple
      ? multipleSelect
      : [midiaSemPlanilha.id];

    const text = isMultiple
      ? `Deseja sinalizar mídia atribuída para todos os ${multipleSelect.length} envios selecionados?`
      : `Sinalizar Mídia Atribuída para: ${midiaSemPlanilha.comercial.titulo}`;

    const successMessage = isMultiple
      ? 'Mídias atribuídas sinalizadas!'
      : 'Mídia Atribuída sinalizada!';

    dispatch(
      show({
        type: 'question',
        text,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: '/enviaexibidor/midiaatribuida',
          method: api.patch,
          data: { ids },
          action: 'midiaatribuida',
        },
        haveCallback: true,
        successMessage,
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      }),
    );
  }, [dispatch, multipleSelect]);


  const handlePlayer = useCallback(
    preview_url => {
      if (preview_url) {
        setPlayer({
          open: !player.open,
          midia_url: preview_url,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  // fecha player
  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const checkAllComponent = useCallback(() => {
    if (multipleSelect.length === 0) {
      return (
        <Button
          fill
          color="font"
          round
          style={{
            top: '-3px',
            position: 'absolute',
            left: '-9px',
          }}
          disabled={false}
          onClick={e => handleSelectAll(e, true)}
        >
          <FiSquare size={26} />
        </Button>
      );
    }

    if (
      multipleSelect.length > 0 &&
      multipleSelect.length < semPlanilha.length
    ) {
      return (
        <Button
          fill
          color="font"
          round
          style={{
            top: '-3px',
            position: 'absolute',
            left: '-9px',
          }}
          disabled={false}
          onClick={e => handleSelectAll(e, false)}
        >
          <FiMinusSquare size={26} />
        </Button>
      );
    }

    if (multipleSelect.length <= semPlanilha.length) {
      return (
        <Button
          fill
          color="font"
          round
          style={{
            top: '-3px',
            position: 'absolute',
            left: '-9px',
          }}
          disabled={false}
          onClick={e => handleSelectAll(e, false)}
        >
          <FiCheckSquare size={26} />
        </Button>
      );
    }
  }, [handleSelectAll, multipleSelect.length, semPlanilha.length]);

  // const handleArquiva = async (e: React.MouseEvent, sp: EnviaExibidor) => {
  //   e.preventDefault();
  //   setSelected(sp);
  //   try {
  //     const option = {
  //       type: 'question',
  //       text: `Deseja deletar o envio de ${sp.comercial.titulo}?`,
  //       confirmButtonText: 'CONFIRMAR',
  //       callback: {
  //         url: `/enviaexibidor/${sp.id}`,
  //         method: api.delete,
  //         action: 'arquiva',
  //       },
  //       haveCallback: true,
  //       successMessage: 'Envio deletado!',
  //       cancelButtonText: 'NÃO',
  //       showCancelButton: false,
  //       showConfirmButton: true,
  //       showCloseButton: true,
  //     };
  //     dispatch(show(option));
  //   } catch (e) {
  //     if (e instanceof Error) toast.error(e.message);
  //     else if (e instanceof AppError) toast.error(e.message);
  //     else {
  //       const appError = e as AppError;
  //       if (appError.message)
  //         toast.error(appError.message, {
  //           toastId: appError.message,
  //         });
  //       else toast.error('Erro inesperado');
  //     }
  //   }
  // };
  /**
   * USE EFFECT
   */
  // Reset page when emissora changes
  useEffect(() => {
    setPage(1);
  }, [emissora.value]);

  useEffect(() => {
    const controller = new AbortController();
    async function loadSemPlanilha() {
      setLoading(true);
      try {
        const response = await api.get(`/dashboard/comerciaissemplanilha`, {
          signal: controller.signal,
          params: {
            page: page,
            emissora_id: emissora.value,
            ...(search && { search: search }),
          },
        });
        if (response && response.data) {
          setSemPlanilha(response.data.enviosSemPlanilha);
          setPages(response.data.pages);
          setMultipleSelect([]);
        }
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      } finally {
        setLoading(false);
      }
    }
    loadSemPlanilha();
    return () => {
      controller.abort();
    };
  }, [emissora.value, search, page]);

  // verifica se callback foi realizado com sucesso para então remover item da lista
  useEffect(() => {
    if (callbackDialog && callbackDialog.success)
      if (callbackDialog.success.action === 'midiaatribuida' && multipleSelect.length > 1) {
        setMultipleSelect([]);
        setSemPlanilha(prevState =>
          prevState.filter(sp => !multipleSelect.includes(sp.id)),
        );
      } else if (
        (callbackDialog.success.action === 'autoriza' || callbackDialog.success.action === 'midiaatribuida') &&
        selected
      ) {
        setSemPlanilha(prevState =>
          prevState.filter(sp => sp.id !== selected.id),
        );
        setMultipleSelect([]);
      }
  }, [callbackDialog, selected, multipleSelect]);

  return (
    <Container>
      <nav>
        <Button color="primary" onClick={() => navigate(-1)}>
          VOLTAR
          <FiArrowLeft />
        </Button>
        <div />
        <Button
          color="primary"
          disabled={multipleSelect.length < 1}
          onClick={e => handleMidiaAtribuida(e, semPlanilha)}
        >
          MÍDIA ATRIBUÍDA <FiCheck />
        </Button>
      </nav>
      <Card>
        <header>
          <h4>COMERCIAIS SEM PLANILHA</h4>
          <Pagination
            total={pages}
            activePage={page}
            onClick={page => {
              setPage(page);
              setMultipleSelect([]);
            }}
          />
          <div>
            <Form
              onSubmit={e => {
                setPage(1);
                setSearch(e.searchLocal);
              }}
            >
              <Input
                name="searchLocal"
                placeholder="Buscar na Tabela"
                icon={<FiSearch />}
              />
            </Form>
          </div>
        </header>
        {loading ? (
          <Loader />
        ) : (
          <Scroll>
            <Form ref={formTableRef} onSubmit={() => { }}>
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '15px' }} />
                    <th style={{ position: 'relative', width: '63px' }}>
                      {checkAllComponent()}
                    </th>
                    <th style={{ width: '90px' }}>CM</th>
                    <th>TITULO</th>
                    <th style={{ width: '90px' }}>DUR</th>
                    <th style={{ width: '160px' }}>STATUS</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>
                      RECEBIDO EM
                    </th>
                    <th style={{ width: '90px' }} />
                  </tr>
                </thead>
                <tbody>
                  {!!semPlanilha &&
                    semPlanilha.map((sp, index) => (
                      <tr
                        key={sp.id}
                        onClick={e => {
                          e.preventDefault();
                          handleSelectEnvio(sp);
                        }}
                      >
                        <TdFlag $isGe={sp.comercial.globoexpress}>
                          <div id={`tdFlag_id${index}`} />
                          <Tooltip
                            target={`tdFlag_id${index}`}
                            position="right"
                          >
                            <p>
                              <strong>PRIORITÁRIO:</strong> GLOBO EXPRESS
                            </p>
                          </Tooltip>
                        </TdFlag>
                        <Td>
                          <Checkbox
                            key={sp.id}
                            name={`checkbox_${sp.id}`}
                            options={[{ id: sp.id, label: '' }]}
                            columns="1fr"
                          />
                        </Td>
                        <Td>{sp.comercial.codmaterial}</Td>
                        <Td>
                          {sp.comercial.titulo}{' '}
                          <strong>({sp.comercial.cliente.mnemonico})</strong>
                        </Td>
                        <Td>{sp.comercial.duracao} s</Td>
                        <Td>
                          <Flag
                            type={sp.statusgeral.type}
                            name={sp.statusgeral.nome}
                            tooltip={sp.statusgeral.info}
                          />
                        </Td>
                        <Td style={{ textAlign: 'center' }}>
                          {format(new Date(sp.created_at), 'dd/MM/yyyy')}
                        </Td>
                        <Td>
                          <Align>
                            <Button
                              id={`id_assistir_${sp.id}`}
                              fill
                              color="font"
                              round
                              onClick={e => {
                                e.stopPropagation();
                                handlePlayer(sp.comercial.midia?.preview_url);
                              }}
                            >
                              <FiTv />
                              <Tooltip target={`id_assistir_${sp.id}`}>
                                ASSISTIR
                              </Tooltip>
                            </Button>
                            <Button
                              id={`id_atribuir_${sp.id}`}
                              fill
                              color="font"
                              round
                              onClick={e => {
                                e.stopPropagation();
                                handleMidiaAtribuida(e, sp);
                              }}
                              disabled={
                                sp.status === StatusEnviaExibidor.CONCLUIDO ||
                                sp.status === StatusEnviaExibidor.INGESTMANUAL
                              }
                            >
                              <FiCheck />
                            </Button>
                            <Tooltip target={`id_atribuir_${sp.id}`} position="left">
                              ATRIBUIR MÍDIA
                            </Tooltip>
                          </Align>
                        </Td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Form>
          </Scroll>
        )}
      </Card>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
